function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19.4,9.6l-9-9C10,0.2,9.5,0,9,0H2C0.9,0,0,0.9,0,2v7c0,0.5,0.2,1,0.6,1.4l9,9C10,19.8,10.5,20,11,20 s1-0.2,1.4-0.6l7-7C19.8,12,20,11.5,20,11S19.8,9.9,19.4,9.6z M11,18L2,9V2h7v0l9,9L11,18z M7.9,6.5l1.4-1.4l1.4,1.4L7.9,9.3L8.6,10 l2.1-2.1c0.4-0.4,1-0.4,1.4,0l2.1,2.1c0.4,0.4,0.4,1,0,1.4l-0.7,0.7l0.7,0.7l-1.4,1.4l-0.7-0.7l-1.4,1.4l-1.4-1.4l2.8-2.8L11.4,10 l-2.1,2.1c-0.4,0.4-1,0.4-1.4,0L5.8,10c-0.4-0.4-0.4-1,0-1.4l0.7-0.7L5.8,7.2l1.4-1.4L7.9,6.5z M4.5,6C3.7,6,3,5.3,3,4.5 S3.7,3,4.5,3S6,3.7,6,4.5S5.3,6,4.5,6z"
});

var SvgEstimatedTotal = function SvgEstimatedTotal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstimatedTotal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estimated_total.578e85e7.svg";
export { ForwardRef as ReactComponent };